<template>
  <v-ons-page id="home">
    <v-ons-toolbar class="toolbar-nav toolbar-customize toolbar toolbar--transparent" modifier="transparent">
      <nav-bar :floating="navFloating" :loading="initLoading" :featured-tags="homeData && homeData.featured_tags"></nav-bar>
    </v-ons-toolbar>
    <v-ons-progress-bar indeterminate class="app-bar-progress" v-show="loading"></v-ons-progress-bar>
    <top-pull-hook id="home-pull-hook" :action="reload" />
    <main role="main"
      v-bind:class="{ 'ph-animate': initLoading }"
    >
      <h1 class="page-title center-align bg-white" style="position: relative; z-index: 2;">
        <img class="non-darkmode-only" src="@/assets/img/logo.svg" alt="Edifi" width="100" height="59">
        <img class="darkmode-only" src="@/assets/img/logo-white.svg" alt="Edifi" width="100" height="59">
      </h1>
      <promotion-carousel :loading="initLoading" :promotions="homeData && homeData.promotions" />
      <new-episodes :loading="initLoading" :new-episodes="homeData && homeData.new_episodes" />
      <unfinished-episodes :loading="initLoading" :unfinished-episodes="homeData && homeData.unfinished_episodes" />
      <!-- <trending-episodes :loading="initLoading" :trending-episodes="homeData && homeData.trending_episodes" /> -->
      <recommended-channels v-if="!initLoading" :recommended-channels="homeData && homeData.recommended_channels" />
      <!-- <featured-channels v-if="!initLoading" :featured-channels="homeData && homeData.featured_channels" /> -->
      <featured-tag
        v-for="tag in homeData && homeData.featured_tags || []"
        :key="tag.id"
        :tag="tag"
        v-if="!initLoading"
      />
    </main>
    <float-player />
  </v-ons-page>
</template>

<script>
import NavBar from '@/components/home/NavBar.vue';
import TopPullHook from '@/components/TopPullHook.vue';
import PromotionCarousel from '@/components/home/PromotionCarousel.vue';
import NewEpisodes from '@/components/home/NewEpisodes.vue';
import UnfinishedEpisodes from '@/components/home/UnfinishedEpisodes.vue';
import TrendingEpisodes from '@/components/home/TrendingEpisodes.vue';
import RecommendedChannels from '@/components/home/RecommendedChannels.vue';
import FeaturedChannels from '@/components/home/FeaturedChannels.vue';
import FeaturedTag from '@/components/home/FeaturedTag.vue';
import FloatPlayer from '@/components/FloatPlayer.vue';
import Home from '@/models/Home';
import PopupHelper from '@/mixins/PopupHelper';
import WatchUserChangeHelper from '@/mixins/WatchUserChangeHelper';
import { onUiLanguageInitReady } from '@/i18n';

export default {
  name: 'home',
  components: {
    'nav-bar': NavBar,
    'top-pull-hook': TopPullHook,
    'promotion-carousel': PromotionCarousel,
    'new-episodes': NewEpisodes,
    'unfinished-episodes': UnfinishedEpisodes,
    'trending-episodes': TrendingEpisodes,
    'recommended-channels': RecommendedChannels,
    'featured-channels': FeaturedChannels,
    'featured-tag': FeaturedTag,
    'float-player': FloatPlayer,
  },
  mixins: [PopupHelper, WatchUserChangeHelper],

  data() {
    return {
      initLoading: true,
      loading: true,
      homeSectionEls: [],
      navBar: null,
      navBarUl: null,
      currentNavId: '',
      navFloating: false,
      onScrollDone: null
    };
  },

  computed: {
    homeData() {
      return Home.query().with('promotions').with('new_episodes.channel').with('unfinished_episodes.channel').with('trending_episodes.channel').with('recommended_channels').with('featured_channels').with('featured_tags.channels').with('featured_tags.episodes.channel').first();
    },
  },

  watch: {
    '$i18n.locale': function(newVal, oldVal) {
      this.reload();
    }
  },

  methods: {
    reload(done) {
      let page = this.$el;
      let pageContent = page && page.querySelector('.page__content');
      let that = this;

      this.initLoading = true;
      this.loading = true;
      Home.fetch()
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            that.navigatorResetLogin(that.$t("messages.login_required"));
          } else {
            console.log(error);
            that.showSomethingWrongToast();
          }
        }).finally(() => {
          this.initLoading = false;
          this.loading = false;
          if (done) { done(); }
        });
    },
    updateSectionEls() {
      this.homeSectionEls = this.$el.querySelectorAll('.home-section');
    },
    getCurrentNavId() {
      let str = '';
      window.forEach(this.homeSectionEls, (section) => {
        if (!str) {
          const rect = section.getBoundingClientRect();
          const center = 44;
          if (rect.top <= center && rect.bottom > center) {
            str = section.id;
          }
        }
      });
      return str;
    },
    updateNav(dontScrollNav) {
      const newId = this.getCurrentNavId();
      const navActiveCl = 'active';

      let isInViewport = (elem) => {
        const rect = elem.getBoundingClientRect();
        return (
          rect.top >= 0
            && rect.left >= 0
            && rect.bottom <= (window.innerHeight || window.html.clientHeight)
            && rect.right <= (window.innerWidth || window.html.clientWidth)
        );
      };

      // update nav style
      if (this.navBar.getBoundingClientRect().top >= 5) {
        this.navFloating = false;
      } else {
        this.navFloating = true;
      }

      // update nav items
      if (newId !== this.currentNavId) {
        // remove old
        if (this.currentNavId) {
          this.navBarUl.querySelector(`[href="#${this.currentNavId}"]`).parentNode.classList.remove(navActiveCl);
        }
        // add new
        if (newId) {
          const li = this.navBarUl.querySelector(`[href="#${newId}"]`).parentNode;
          li.classList.add(navActiveCl);
          if (!isInViewport(li) && !dontScrollNav) {
            let that = this;
            that.onScrollDone = () => {
              li.scrollIntoView({ behavior: 'smooth' });
              that.onScrollDone = null;
            };
          }
        }
        // reset id
        this.currentNavId = newId;
      }
    },
    onUserChanged() {
      this.reload();
    },
  },

  created() {
    this.reload();
  },

  mounted() {
    let ticking;
    let component = this;
    const page = this.$el;
    let pageContent = page.querySelector('.page__content');

    window.addEventListener('resize', () => {
      component.updateNav();
    });

    let scrollCounter = 0;
    let checkingScrollDone = false;
    let checkScrollDone = () => { // invoke onScrollDone after 200ms not scrolling
      scrollCounter++;
      if (scrollCounter < 2) {
        setTimeout(checkScrollDone, 100);
        return;
      }
      scrollCounter = 0;
      checkingScrollDone = false;
      if (component.onScrollDone) { component.onScrollDone(); }
    };

    let scrollingIntoView = 0;
    let onscroll = (e) => {
      // skip this listener if it was scrolling a split moment (500ms) ago
      let dontScrollNav = false;
      if (scrollingIntoView > e.timeStamp - 500) {
        scrollingIntoView = e.timeStamp;
        dontScrollNav = true;
      }
      if (!dontScrollNav) {
        scrollCounter = 0;
        if (!checkingScrollDone) {
          checkingScrollDone = true;
          setTimeout(checkScrollDone, 100);
        }
      }
      // nav update
      if (!ticking) {
        ticking = true;
        window.raf(() => {
          component.updateNav(dontScrollNav);
          ticking = false;
        });
      }
    };

    // nav
    this.navBar = page.querySelector('.home-navbar');
    this.navBarUl = this.navBar.querySelector('ul');
    if (this.navBarUl) {
      this.navBarUl.onclick = (e) => {
        const el = window.lookupByType(e.target, 'a');
        const href = el.getAttribute('href');
        if (el && href) {
          e.preventDefault();
          scrollingIntoView = e.timeStamp;
          page.querySelector(href).scrollIntoView({ behavior: 'smooth' });
        }
      };
    }

    // scroll
    if (this.homeSectionEls.length) {
      component.updateNav();
    }
    
    pageContent = page.querySelector('.page__content');
    if (pageContent) {
      pageContent.addEventListener('scroll', onscroll);
    }

    onUiLanguageInitReady(() => {
      this.showLanguageSelectModal().then(() => {
        // show pwa install prompt if ok
        setTimeout(() => {
          this.$a2hs.show();
          this.showTipsDialog();
          this.showRateAppDialog();
        }, 3000);
      });
    });
  },

  updated() {
    this.updateSectionEls();
  }
};
</script>
